export default __webpack_public_path__ + "static/media/wallpaper_bg7.4493ba66.jpg";